export interface InstantConfigLoaderParams {
	appName: string;
	instantConfigEndpoint?: string;
	instantConfigFallbackEndpoint?: string;
	instantConfigVariant?: string;

	requestTimeout?: number;
}
